import { gql } from '@apollo/client'
import { head } from 'ramda'
import React from 'react'

import { generalClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useConfigState = () => React.useContext(Context)
export const useConfig = () => useConfigState()?.config

const QUERY = gql`
  query Configs($name: String) {
    configs(filter: { name: $name }) {
      id
      name
      value
      updatedAt
      insertedAt
    }
  }
`

const ConfigLoader = ({ children }) => {
  const { name } = useModalData() || {}

  const { data, ...state } = useQuery(QUERY, {
    variables: { name: name },
    skip: !name,
    client: generalClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={{ ...data, config: head(data?.configs || []) }}>{children}</Provider>
    </StatePresenter>
  )
}

export default ConfigLoader
